
import { requests } from '.'
import { Filter } from '../commons/Types';
import ListData from '../models/List.model';
import Video from '../models/Video.model';

export const VideoApi = {
  list: (filter: Filter) => requests.get<ListData<Video>>('v1/video', filter), 
};